import { AppEntity, ContactInformationSchema, PostalAddressSchema } from '@app/icare/db/schema/common'
import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

export const IKNumberSchema = z.object({
  ikNumber: z.coerce.string(),
  address: PostalAddressSchema.nullish(),
})

export const CostCarrierId = entityId('costCarrier')

export type CostCarrierIdType = typeof CostCarrierId.Type

export const CostCarrierSchema = AppEntity.extend({
  id: CostCarrierId.schema,
  name: z.string().min(1).max(255),
  addition: z.coerce.string().nullish(),
  comment: z.coerce.string().nullish(),
  address: PostalAddressSchema.nullish(),
  contact: ContactInformationSchema.nullable(),
  ikNumber: z.object({
    main: IKNumberSchema.nullish(),
    secondary: z.array(IKNumberSchema),
  }),
})

export type CostCarrier = z.infer<typeof CostCarrierSchema>
